module.exports = __webpack_public_path__ + "img/prior_interventions.87b581e4.svg";